import { Paragraph } from '@welbe/web-design-system';
import { Outlet } from 'react-router-dom';
import { ReactComponent as Logo } from 'App/assets/logo.svg';
import packageLock from '../../../package.json';
import { Container, Wrapper, WrapperHeader } from './Login.style';

const Login = () => {
	return (
		<Container>
			<Wrapper>
				<WrapperHeader>
					<Logo width="300px" />
				</WrapperHeader>
				<Outlet />
			</Wrapper>
			<Paragraph margin="15px 0">Versión {packageLock.version}</Paragraph>
		</Container>
	);
};

export { Login };
